import { render } from "./WorkerEditor.vue?vue&type=template&id=7a936f3c"
import script from "./WorkerEditor.vue?vue&type=script&lang=js"
export * from "./WorkerEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__